import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
};

const scoreSlice = createSlice({
  name: "score",
  initialState,
  reducers: {
    scoreArray: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { scoreArray } = scoreSlice.actions;
export default scoreSlice.reducer;
